import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/registro_sanitario/clasificacion';
import Clasificacion from './Clasificacion';


const ms2p = (state) => {
  return {
    ...state.rs_clasificacion,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Clasificacion);